module.exports = __webpack_public_path__ + "img/Comic_26.46b09574.png";